var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m26.375395 12.5051844c.8255638-.0688174 1.5506031.5446467 1.6194206 1.3702106.0688174.8255638-.5446467 1.5506031-1.3702106 1.6194206-3.710826.3093275-7.918482.4636541-12.624605.4636541s-8.91377902-.1543266-12.62460503-.4636541c-.82556384-.0688175-1.439028-.7938568-1.37021054-1.6194206.06881746-.8255639.79385676-1.439028 1.6194206-1.3702106 3.62250732.3019655 7.74818463.4532853 12.37539497.4532853 4.6272103 0 8.7528876-.1513198 12.375395-.4532853z","fill":"#fff6e3"}));
}

Minus.defaultProps = {"height":"28","viewBox":"0 0 28 28","width":"28"};

module.exports = Minus;

Minus.default = Minus;
